export const SANITY_PROJECT_ID = 'ivaqw3e8';
export const appSanityAssetPath = `https://cdn.sanity.io/images/${SANITY_PROJECT_ID}/${import.meta.env.VITE_SANITY_ENV}`;
